import React from "react";
import { buildValueToLabel } from "./tacticModel";
import "./TacticEditor.css";

function flattenQuery(query, syntaxByValue) {
  if (!query) return [];

  switch (query.kind) {
    case "atom":
      return [{ type: "atom", value: query.value, arg: query.arg ?? null }];

    case "not":
      return [{ type: "op", label: syntaxByValue[8] ?? "NOT" }, ...flattenQuery(query.operand, syntaxByValue)];

    case "and":
      return [
        ...flattenQuery(query.left, syntaxByValue),
        { type: "op", label: syntaxByValue[6] ?? "AND" },
        ...flattenQuery(query.right, syntaxByValue),
      ];

    case "or":
      return [
        ...flattenQuery(query.left, syntaxByValue),
        { type: "op", label: syntaxByValue[7] ?? "OR" },
        ...flattenQuery(query.right, syntaxByValue),
      ];

    default:
      return [];
  }
}

/**
 * @param {{ query: object, queryTokens: Record<string,number>, syntaxTokens: object, onEdit: ()=>void }} props
 */
export function QueryDisplay({ query, queryTokens, syntaxTokens, zones, onEdit }) {
  const syntaxByValue = buildValueToLabel(syntaxTokens ?? {});
  const tokens   = flattenQuery(query, syntaxByValue);
  const byValue  = buildValueToLabel(queryTokens);
  const zoneByValue = buildValueToLabel(zones ?? {});

  return (
    <div className="query-display" onClick={onEdit} title="Tap to edit condition">
      {tokens.map((t, i) =>
        t.type === "op"
          ? <span key={i} className="query-op">{t.label}</span>
          : (
            <span key={i} className="query-chip">
              {byValue[t.value] ?? t.value}
              {t.arg != null && (
                <span className="query-chip-arg">({zoneByValue[t.arg] ?? t.arg})</span>
              )}
            </span>
          )
      )}
    </div>
  );
}
